import InlineAlert from "@storeblocks/inline-alert";
import React from "react";
import {
  CoverageNeed,
  ProductCoverageName,
} from "Store/akaAdvice/interfaces/CollectiveAdvice";
import { isAllowed, isCloseToMaxAge } from "Store/akaAdvice/interfaces/getters";
import { TextLanguage, TranslatedText } from "Store/texts/interfaces";
import { isDefined } from "Utils/functions";
import { replacePlaceholder } from "Utils/replacePlaceholder";

export type WarningTexts = Partial<
  Record<ProductCoverageName, CoverageWarningTexts>
>;

export type CoverageWarningTexts = {
  closeToMaxAge: TranslatedText;
  closeToMaxAgeShort: TranslatedText;
};

export type WarningVariables = {
  maxAge: number;
  endAge: number;
};

interface Props {
  need: CoverageNeed;
  coverageName: ProductCoverageName;
  warningTexts: WarningTexts;
  lang: TextLanguage;
  warningVariables: WarningVariables;
}

export const CloseToMaxAgeWarning = ({
  need,
  coverageName,
  warningTexts,
  lang,
  warningVariables,
}: Props): React.ReactElement | null => {
  if (!isAllowed(need, coverageName) || !isCloseToMaxAge(need, coverageName)) {
    return null;
  }

  const coverageWarningTexts = warningTexts[coverageName];
  if (!isDefined(coverageWarningTexts)) {
    return null;
  }

  return (
    <InlineAlert
      title={replacePlaceholder(coverageWarningTexts.closeToMaxAge[lang], {
        maxAge: String(warningVariables.maxAge),
        endAge: String(warningVariables.endAge),
      })}
    />
  );
};
